const applyFilters = container => {
    const query = container.querySelector('[data-live-table-search]').value.trim().toLocaleLowerCase();
    const availability = container.dataset.liveTableAvailability;
    let matches = 0;

    container.querySelectorAll('[data-live-table-row]').forEach(row => {
        row.hidden = !row.cells[0].textContent.toLocaleLowerCase().includes(query)
            || Boolean(availability && row.dataset.availability !== availability);
        matches += row.hidden ? 0 : 1;
    });

    container.querySelector('[data-live-table-empty]').hidden = matches > 0;
};

export const filterLiveTable = event => {
    const input = event.target.closest('[data-live-table-search]');

    if (input) {
        applyFilters(input.closest('[data-live-table]'));
    }
};

export const filterLiveTableAvailability = event => {
    const button = event.target.closest('[data-live-table-status]');

    if (!button) {
        return;
    }

    event.preventDefault();
    const container = button.closest('[data-live-table]');
    container.dataset.liveTableAvailability = button.dataset.liveTableStatus;
    container.querySelectorAll('[data-live-table-status]').forEach(control => {
        control.setAttribute('aria-pressed', String(control === button));
    });
    applyFilters(container);
};

export const sortLiveTable = event => {
    const button = event.target.closest('[data-live-table-sort]');

    if (!button) {
        return;
    }

    event.preventDefault();

    const container = button.closest('[data-live-table]');
    const header = button.closest('th');
    const descending = header.getAttribute('aria-sort') === 'ascending';
    const column = Number(button.dataset.liveTableSort);
    const rows = Array.from(container.querySelectorAll('[data-live-table-row]'));
    const collator = new Intl.Collator(undefined, {sensitivity: 'base'});

    rows.sort((left, right) => {
        const leftValue = left.cells[column].dataset.sortValue ?? left.cells[column].textContent.trim();
        const rightValue = right.cells[column].dataset.sortValue ?? right.cells[column].textContent.trim();
        const comparison = button.dataset.sortType === 'number'
            ? Number(leftValue) - Number(rightValue)
            : collator.compare(leftValue, rightValue);

        return (descending ? -comparison : comparison)
            || collator.compare(
                left.cells[0].dataset.sortValue ?? left.cells[0].textContent.trim(),
                right.cells[0].dataset.sortValue ?? right.cells[0].textContent.trim(),
            );
    });

    const emptyRow = container.querySelector('[data-live-table-empty]');
    rows.forEach(row => emptyRow.before(row));

    container.querySelectorAll('[data-live-table-sort]').forEach(control => {
        const selected = control === button;
        control.closest('th').setAttribute('aria-sort', selected ? (descending ? 'descending' : 'ascending') : 'none');
        control.querySelector('[data-sort-ascending]').hidden = !selected || descending;
        control.querySelector('[data-sort-descending]').hidden = !selected || !descending;
    });
};
